<template>
  <div class="app">
	  <van-tabs v-model="active" @change="change" sticky color="#3E78F7" class="header">
			<van-tab v-for='(item,index) in navList' :key="index" :title="item.title">
				<div class="nav-contents">
					<van-list v-model="loading"  offset="20" :finished="finished" :finished-text="finishedTxt" @load="onLoad">
						<fbxxCard :list="list" :pth="text" :clearType="index"></fbxxCard>
					</van-list>
				</div>
			</van-tab>
		</van-tabs>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import{httpAction,getAction,putAction} from "@/api/manage"
import { Toast,Picker } from 'vant'
import fbxxCard from '../common/fbxx-card'
export default {
	components:{fbxxCard},
	data(){
		return{
			text:"/hmhq/wallDetail",
			navList:[
				{
					title:"已发布",
					code:'03',
					id:1,
				},
				{
					title:"待审核",
					code:'01',
					id:2,
				},
				{
					title:"审核未通过",
					code:'02',
					id:3,
				},
				{
					title:"已结束",
					code:"04",
					id:4,
				}
			],
			status:'03',
			active: 0,
			list:[],
			keyword: '',
			loading: false,
			finished: false,
			refreshing: false,
			finishedTxt:"",
			pageNo:0,
		}
	},
	mounted() {
		this.onRefresh();
	},
	methods:{
		init(){
			let openId = this.$store.getters.openId;
      		let params = {pageNo:this.pageNo,openId:openId,status:this.status};
			getAction('/zhshj/hmfwggq/page',params)
			.then((res)=>{
				if (this.refreshing) {
					this.list = [];
					this.refreshing = false;
                }
				this.loading = false;
				this.finished = true;
				let data = res.result.records
				console.log("res",data);
				data.map((item,index)=>{
                    if(typeof(item.fmtp)=="string"){
                        item.fmtp = item.fmtp.split(",")
                    }
                    if(item.fmtp==null){
                        item.fmtp = [""]
					}
					switch(item.fl){
						case '01' : item.imgType = require("@images/icon2/swzl-card.png");break;
						case '02' : item.imgType = require("@images/icon2/fwzl-card.png");break;
						case '03' : item.imgType = require("@images/icon2/zpxx-card.png");break;
						case '04' : item.imgType = require("@images/icon2/jypx-card.png");break;
						case '99' : item.imgType = require("@images/icon2/other-card.png");break;
					}
                })
				this.list = this.list.concat(data)
				if(res.result.pages <= this.pageNo){
					this.finished = true;
					if(this.pageNo!=1){
						this.finishedTxt = "暂无更多了"
					}
				}
			})
		},
		change(idx){
			console.log("当前标签下标",idx);
			this.status = this.navList[idx].code;
			this.pageNo = 0;
			this.onRefresh();
        },
		goPage(item){
			console.log("跳转",item);
			this.$router.push({
				path:"/hmhq/wall-list",
				query:item
			})
		},
		onLoad(){
			this.pageNo++
			this.init();
		},
		clickSearch1() {
			this.refreshing = true;
			this.onRefresh();
		},
		goPublish(id){
			console.log("id",id);
			this.$router.push({
				path:"/hmhq/publish",
				query:{
					id:id
				}
			})
		},
		onRefresh() {
			// 清空列表数据
			this.finished = false;
			this.finishedTxt = ""
			// 重新加载数据
			// 将 loading 设置为 true，表示处于加载状态
			this.loading = true;
			this.pageNo = 0;
			this.refreshing  = true;
			this.onLoad();
		},
	}
}
</script>

<style scoped lang="less">
.app{
	width: 100%;
	height: 100vh;
	//overflow: hidden;
	background-color: #f6f7f9;
}
p{
	margin: 0px;
	padding: 0px;
}
input{
	border: none
}
.header{
	background-color: #f6f7f9;
}
.nav-contents{
	padding: 10px 0px 0px;
}
</style>